import React, { Component, useState, useEffect } from 'react'
import moment from "moment";
import FilterActiveIcon from "../../../icons/filteractiveicon";
import FilterIcon from "../../../icons/filtericon";
import service from "../../../services";
import MainLayout from '../../../mainLayout/index';
import PlusIcon from '../../../icons/plusicon';
import UserImage from "./../../../assets/images/user.jpg";
import Loader from "../../loader";
import serachIcon from '../../../assets/images/search.svg'
// import serachIcon from './../assets/images/search.svg'

//Redux Connect
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";

import { Link, useHistory } from 'react-router-dom'
import AddPrivateEvents from '../../../pages/AddPrivateEvents';


let sub;
let statusFilterList = []

const mapDispatchToProps = dispatch => {
	return bindActionCreators(ActCreators, dispatch)
};

function PrivateEventsList(props) {
  const history = useHistory();
	const privateEvent_L = useSelector(state => state.PrivateEventList)
  

  const [status, setStatus] = useState([
    { assign: "Live", list: 1, value: false },
    { assign: "Disable", list: 2, value: false },
  ])
  const [apiserve, setApiserve] = useState(new service());
  const [getLastUpdated, setGetLastUpdated] = useState('');
  const [searchEvent, setSearchEvent] = useState({
    status: [],
    filter: '',
    limit: 10,
    page: 1
  });
  const [statusData, setStatusData] = useState([])
  const [totalEvent, setTotalEvent] = useState(0)

  useEffect(() => {
    apiserve.sendevent("fpg|privateEvent|getList", {})
    eventCall();
    return () => {
      sub.unsubscribe();
      statusFilterList = [];
    }
  }, [])

  // get search list 
  useEffect(() => {
    if (searchEvent.filter !== '') {
      let data = {
        page: 1,
        status: statusData.length != 0 ? statusData : [1, 2],
        filter: searchEvent.filter ? searchEvent.filter : '',
      }
      apiserve.sendevent("fpg|privateEvent|getList", data);
    }
    else {
      apiserve.sendevent("fpg|privateEvent|getList", {})
    }
  }, [searchEvent.filter])

  const eventCall = () => {
    sub = apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "fpg|privateEvent|getList":
          if (!response.error) {
            props.GetPrivateEventTable(response.data.docs)
            setTotalEvent(response.data.docs.length)
          }
          break;
        default:
          break;
      }
    })
  }

  const StatusFilter = (e, i) => {
    let statusArray = Object.assign([], status);
    if (e !== 'clearStatus') statusArray[i].value = e.target.checked
    else statusArray.map(e => {
      e.value = false;
      return e
    })
    setStatus(statusArray)
    getStatusFilter()
  }

  // get status list
  const getStatusFilter = () => {
    let data = {
      page: 1,
    }
    if (checkStatus()) {
      data.status = []
      status.forEach(e => {
        if (e.value) data.status.push(e.list)
      })
      setStatusData(data.status)
    } else setStatusData([])

    if (searchEvent.filter !== '') {
      data.filter = searchEvent.filter
    }
    apiserve.sendevent("fpg|privateEvent|getList", data);
  }

  //Search Filter 
  const onSearchFilter = (e) => {
    const { name, value } = e.target

    setSearchEvent({
      ...searchEvent,
      [name]: value
    })
  }

  // edit private event
  const editPrivateEvent = (i) => {
    props.GetPrivateEventEdit(privateEvent_L[i]._id);
    history.push('add-private-events');
  }
  
  
  //check status
  const checkStatus = () => {
    return status.findIndex(e => e.value) !== -1
  }
  const addPrivateEvents = () => {
    props.GetPrivateEventEdit('');
    history.push('add-private-events');
	}

  return (
    <>
      <ul className="search_header">
        <li className="relative">
          <div className="dashboard_header with_btn">
            <div className="searchBlock">
              <span>Private Events ({totalEvent})</span>
              <form onSubmit={e => { e.preventDefault(); }}>
                <input
                  type="text"
                  placeholder="Search"
                  id="searchField"
                  name="filter"
                  value={searchEvent.filter}
                  onChange={onSearchFilter} />
                <button type='button' style={{ pointerEvents: 'none' }}>
                  <img src={serachIcon} />
                </button>
              </form>
            </div>
            <button className="add_page no_border" onClick={()=>addPrivateEvents()}><PlusIcon /></button>
          </div>
        </li>
      </ul>
      <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
        <p></p>
        <p className="update_date">
          {/* Last Update: {moment(getLastUpdated.updatedAt).tz("US/Mountain").format("h:mm A")}{' '}
					PT- {moment.tz(getLastUpdated.updatedAt, "US/Mountain").format('MM/DD/YYYY')}-
          Last Updated By:{getLastUpdated.updatedBy && `${getLastUpdated.updatedBy.fname}${' '} ${getLastUpdated.updatedBy.lname}`} */}
        </p>
      </div>
      <div className="table_wrap film_list_table striped_table">
        <table className="row_height_tbl">
          <thead>
            <tr>
              <th> <div className="ml_10">Event Name</div></th>
              <th>Event Date-Time (MT)</th>
              <th>Invited</th>
              <th>
                <span className="d_flex d_flex_align_center">
                  Status
                  {checkStatus() ?
                    <FilterActiveIcon />
                    :
                    <FilterIcon />
                  }
                </span>
                <div className="tabelData_popup">
                  <form>
                    <div className="customCheck">
                      <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                        <p className="link" onClick={() => StatusFilter('clearStatus')}> Clear All </p>
                      </div>

                      <div className="customCheckBox">
                        {status.map((item, i) => (
                          <div className="customCheckBox" key={i}>
                            <input
                              type="checkbox"
                              id={"status" + item.list}
                              name={"status" + item.list}
                              value={item.list ? true : false}
                              checked={item.value ? true : false}
                              onClick={(e) => StatusFilter(e, i)}
                            />
                            <label htmlFor={"status" + item.list}>
                              {item.assign}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </form>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {privateEvent_L && privateEvent_L.map((item, index) => {
              var shortDate = new Date(item.date)
              return (
                <tr key={index}
                  onClick={() => editPrivateEvent(index)}
                  className={`pointer ${item.status === 2 ? 'disable' : ''}`}>
                  <td style={{ width: "350px" }}>
                    <div className="disp_flex">
                      <div className="film_desc">
                        <h3>{item.name}</h3>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "300px" }}>
                    <div>
                      {item.dateTime.map(dateItem => {
                        return(
                          <p>{moment.tz(dateItem.startTime, "US/Mountain").format('MMM DD')},{moment(dateItem.startTime).tz("US/Mountain").format("h:mm A")}
                          -{moment.tz(dateItem.endTime, "US/Mountain").format('MMM DD')} ,  {moment(dateItem.endTime).tz("US/Mountain").format("h:mm A")}</p>
                        )
                      })}
                    </div>
                  </td>
                  <td style={{ width: "900px" }}>
                    <div className="font_500 color_blue">
                      {item.totalInvitee}
                    </div>
                  </td>
                  <td style={{ width: "150px" }}>
                    <div>
                      <p>
                        {item.status === 1
                          ? "Live"
                          : item.status === 2
                            ? "Disabled"
                            : ""}
                      </p>
                    </div>
                  </td>
                </tr>
              )

            })}
          </tbody>
        </table>
      </div>
    </>

  )
}
export default connect(
  null,
  mapDispatchToProps
)(PrivateEventsList);